'use strict';

var $ = require('../internals/export');

var IS_PURE = require('../internals/is-pure');

var anObject = require('../internals/an-object');

var getSetIterator = require('../internals/get-set-iterator');

var iterate = require('../internals/iterate'); // `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods


$({
  target: 'Set',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  join: function join(separator) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var sep = separator === undefined ? ',' : String(separator);
    var result = [];
    iterate(iterator, result.push, result, false, true);
    return result.join(sep);
  }
});